//Action Types
export var TERMINALS_RESET_ACTION_TYPE = "terminals/reset";
export var TERMINALS_GET_START_ACTION_TYPE = "terminals/get_start";
export var TERMINALS_GET_SUCCESS_ACTION_TYPE = "terminals/get_success";
export var TERMINALS_SAVE_START_ACTION_TYPE = "terminals/save_start";
export var TERMINALS_SAVE_SUCCESS_ACTION_TYPE = "terminals/save_success";
export var TERMINALS_ORDER_CANCEL_START_ACTION_TYPE = "terminals/cancel_start";
export var TERMINALS_ORDER_CANCEL_SUCCESS_ACTION_TYPE = "terminals/cancel_success";
export var TERMINALS_ORDER_DELETE_START_ACTION_TYPE = "terminals/delete_start";
export var TERMINALS_ORDER_DELETE_SUCCESS_ACTION_TYPE = "terminals/delete_success";
export var TERMINALS_ORDER_SAVE_START_ACTION_TYPE = "terminals/save_order_start";
export var TERMINALS_ORDER_SAVE_SUCCESS_ACTION_TYPE = "terminals/save_order_success";
export var TERMINALS_ORDER_COMPLETE_START_ACTION_TYPE = "terminals/complete_order_start";
export var TERMINALS_ORDER_COMPLETE_SUCCESS_ACTION_TYPE = "terminals/complete_order_success";
export var TERMINALS_CHANGE_STATUS_ORDER_START_ACTION_TYPE = "terminals/change_status_order_start";
export var TERMINALS_CHANGE_STATUS_ORDER_SUCCESS_ACTION_TYPE = "terminals/change_status_order_success";
export var TERMINALS_FETCH_START_ACTION_TYPE = "terminals/fetch_start";
export var TERMINALS_FETCH_SUCCESS_ACTION_TYPE = "terminals/fetch_success";
export var TERMINALS_ORDER_FETCH_START_ACTION_TYPE = "terminals/order_fetch_start";
export var TERMINALS_ORDER_FETCH_SUCCESS_ACTION_TYPE = "terminals/order_fetch_success";
export var TERMINALS_CHECK_STATUS_START_ACTION_TYPE = "terminals/check_status_start";
export var TERMINALS_CHECK_STATUS_SUCCESS_ACTION_TYPE = "terminals/check_status_success";
export var TERMINALS_ERROR_ACTION_TYPE = "terminals/error";
